module.exports = __webpack_public_path__ + "fonts/icomoon-app.b7303e15.ttf";